export default "__VITE_ASSET__5AGieari__"